// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"38":"6f94a834","242":"a4fe211c"}[chunkId] + ".chunk.css");